import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AdjustmentsModule } from '../../modules/adjustments/AdjustmentsModule.tsx';

export const AdjustmentsRouteElement = () => (
  <ModuleContainer moduleID="analysis">
    <AdjustmentsModule />
  </ModuleContainer>
);
